import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

export enum ButtonVariant {
  PRIMARY = "PRIMARY",
  PRIMARY_OUTLINE = "PRIMARY_OUTLINE",
  SECONDARY = "SECONDARY",
  SECONDARY_OUTLINE = "SECONDARY_OUTLINE",
  DARK = "DARK",
  DANGER = "DANGER",
}

export interface ButtonConfig {
  text: string;
  class?: string;
  variant?: ButtonVariant;
  disabled?: boolean;
}

export interface ButtonValidationConfig {
  control: AbstractControl | null | undefined;
  errorText: string;
}

@Component({
  selector: "thera-button",
  standalone: true,
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  imports: [MatButtonModule, CommonModule, MatFormFieldModule, MatInputModule],
})
export class ButtonComponent implements OnInit {
  @Input() showValidation = false;
  @Input() validation?: ButtonValidationConfig;
  @Input() config!: ButtonConfig;
  @Input() disabled = false;
  @Input() iconOnly = false;
  @Input() type = "button";
  @Output() clicked: EventEmitter<any> = new EventEmitter();
  buttonVariant = ButtonVariant;

  ngOnInit() {
    if (!this.config.variant) {
      this.config.variant = ButtonVariant.PRIMARY;
    }
    this.disabled = this.config.disabled ?? this.disabled;
  }

  get showError(): boolean {
    const control = this.validation?.control;
    return !!(control && control.invalid);
  }

  onButtonClick(event: MouseEvent) {
    if (!this.disabled) {
      this.clicked.emit(event);
    }
  }
}